import * as api from './adapter';

// CREW-1277 — bulk upload of seafarer documents with recognition.
//
// Not a JSON:API resource on the backend either (DocumentImportsController):
// a multipart upload in, a staging record out, recognition results pushed over
// DocumentImportsChannel (see utils/cable.js), and one commit that writes the
// documents. Nothing here touches `applicant_documents` or `attachments`
// directly — cancelling an import leaves both untouched by construction.
const JSON_HEADERS = { 'Content-Type': 'application/json' };

export default {
  /**
   * Upload the files and start recognition.
   * @param {string|number} crewingApplicantId
   * @param {File[]} files
   * @param {string} [kind] 'documents' (default) or 'sea_service' — a CV whose
   *   Sea Service table becomes contracts on the Experience tab (CREW-1287)
   * @returns {Promise<{data: Object}>} the import payload (id, status, country, files[])
   */
  create: (crewingApplicantId, files, kind) => {
    const body = new FormData();
    body.append('crewing_applicant_id', crewingApplicantId);
    if (kind) body.append('kind', kind);
    files.forEach((file) => body.append('files[]', file, file.name));
    // Let the browser set the multipart boundary — same trick as uploadAttachment.
    return api.apiRequest('/api/document_imports', { method: 'POST', body }, { 'Content-Type': undefined });
  },

  /** The current state — the fallback when the socket is not there. */
  show: (id) => api.apiRequest(`/api/document_imports/${id}`),

  /**
   * Write the confirmed sea-service rows of a CV as contracts (CREW-1287). A 422
   * carries `apiErrors: [{index, messages}]`, one entry per refused row.
   */
  commitContracts: (id, contracts) => api.apiRequest(
    `/api/document_imports/${id}/commit`,
    { method: 'POST', body: JSON.stringify({ contracts }) },
    JSON_HEADERS,
  ),

  /**
   * Write the confirmed documents. A 422 carries `apiErrors: [{index, messages}]`,
   * one entry per refused card, and nothing has been written.
   */
  commit: (id, documents) => api.apiRequest(
    `/api/document_imports/${id}/commit`,
    { method: 'POST', body: JSON.stringify({ documents }) },
    JSON_HEADERS,
  ),

  /** Ask the model again about a failed file. */
  recognizeFile: (id, fileId) => api.apiRequest(`/api/document_imports/${id}/files/${fileId}/recognize`, { method: 'POST' }),

  /** Cancel: the staging rows and their files go. */
  cancel: (id) => api.apiRequest(`/api/document_imports/${id}`, { method: 'DELETE' }),
};
